import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { WhatsInside } from './components/WhatsInside';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream text-navy" data-id="element-0" data-mp="2wiferaffj2x4">
      <MetaPixel data-id="element-1" data-mp="28u5y0mx2p5cu" />
      <UtmifyScript data-id="element-2" data-mp="28tmex2vosax8" />
      <CountdownBar data-id="element-3" data-mp="28t4lsf4bmctj" />
      <main data-id="element-4" data-mp="28sl5f2ubjwhm">
        <Hero data-id="element-5" data-mp="28s2y9b64bxux" />
        <StatsBar data-id="element-6" data-mp="23vcm2yxfpmes" />
        <Difference data-id="element-7" data-mp="23vulg4fe8gqx" />
        <WhatsInside data-id="element-8" data-mp="23ujk0b9f7l2z" />
        <Bonuses data-id="element-9" data-mp="23v2tr4ox335x" />
        <Offer data-id="element-10" data-mp="23ti6m04xmmi3" />
        <Guarantee data-id="element-11" data-mp="3ik7fce9tu7pl" />
        <Testimonials data-id="element-12" data-mp="3ikqz80j1f669" />
        <Faq data-id="element-13" data-mp="3ijfx0558q6h9" />
        <FinalCta data-id="element-14" data-mp="3ijpdn24eb1aa" />
      </main>
      <Footer data-id="element-15" data-mp="3mlawd43m29se" />
    </div>;
}